import '../less/layout.less';
import 'telstra-ui/resources/telstraui.css';
import 'telstra-ui/resources/themes/pacific.css';
import '../less/material-retianed-styles.less';

import { IApplicationDefinition } from '@apps-config';
import { History } from 'history';
import { LoggerSetUp } from '@utils';
import { Application } from '@applications/service-requests';
import { reducers as serviceRequestReducers } from '@telstra-connect/service-requests/reducers';
import { IFeatureFlags as IServiceRequestFlags } from '@telstra-connect/service-requests/feature-flags/common';
import { IFeatureFlags as IDashboardFlags } from '@telstra-connect/dashboard/feature-flags/common';
import { IFeatureFlags as ISSMFeatureFlags } from '@telstra-connect/self-service-migration/feature-flags';
import { Data } from '@telstra-connect/utils';
import { setFeatureFlags } from '@apps-config/feature-flags';
import type { IReducersMap } from '@telstra-connect/standard-actions/reducers';
import type { IServiceRequestsState } from '@telstra-connect/service-requests/state';

LoggerSetUp.enableLogging();

function getApplication() {
    setFeatureFlags();
    return Application;
}

function getReducer(): IReducersMap<IServiceRequestsState> {
    return serviceRequestReducers as unknown as IReducersMap<IServiceRequestsState>;
}

type TGetSessionDetails = () => { sessionId: string; };
interface ICSFlags {
    customerSupportRebuildPhaseTwo?: boolean
}
interface IMDUMFlags {
    mdum?: boolean;
    viewLegacyDetailsPageonMDUM?: boolean;
}
interface IMobilityFlags {
    mdum?: boolean;
}
interface IApplications {
    [Data.platformAppName]?: IDashboardFlags,
    [Data.serviceRequestAppName]?: IServiceRequestFlags,
    [Data.billingAppName]?: object,
    [Data.selfServiceMigration]?: ISSMFeatureFlags,
    [Data.orderTrackerAppName]?: object,
    [Data.networkPerformanceReports]?: object,
    [Data.supportEnquiryAppName]?: ICSFlags,
    [Data.mobileDataUsageMeterAppName]?: IMDUMFlags,
    [Data.mobilityAppName]?: IMobilityFlags
}

export enum TransactionType {
    SELECTING_A_CATALOGUE = 'SELECTING_A_CATALOGUE',
    TRACKING_SERVICE = 'TRACKING_SERVICE'
}

declare const global: {
    TCONN: {
        getAppRoutingHistory: () => History;
        getSessionDetails: TGetSessionDetails;
        Platform: {
            isSecureAuth: boolean,
            showTNPSModal: (transactionType: TransactionType) => void;
            resolveTargetURL: (targetURL: string) => string;
        },
        ServicePerformance: {
            GetApplication: () => IApplicationDefinition;
        };
        ServiceRequestManagement: {
            GetApplication: () => IApplicationDefinition;
            GetReducers: () => IReducersMap<IServiceRequestsState>;
        };
    };
    applications: IApplications;
};

global.TCONN = { ...global.TCONN };
global.TCONN.ServiceRequestManagement = {
    GetApplication: getApplication,
    GetReducers: getReducer
};

export default global;
